import withText, { TextProvider } from './with-text';
import Text from './text';
export { withText, TextProvider };
export default Text;